import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { RemoteControlService, RemoteControlKey } from '../remote';
import { Router } from '@angular/router';
import { ChannelService } from '../channel/channel.service';
import { Channel } from '../channel/channel.model';
import { ChannelHelper } from '../channel/channel.helper';
import { Store } from '@ngrx/store';
import { PlayerState } from '../player/state/player.reducer';

import { AuthService } from '../core/auth.service';

import * as fromPlayerActions from '../player/state/player.actions';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

  // Maximum itens per line (5 channels)
  columns = 5;
  selectedIndex = -1;
  version = environment.version

  // Whether to display a welcome message
  welcomeMessage = '';

  // Local channel information
  channels: Channel[] = [];
  currentChannel!: Channel;

  remoteMonitor!: Subscription;

  constructor(
    private router: Router,
    private remote: RemoteControlService,
    private channelService: ChannelService,
    private playerStore: Store<PlayerState>,
    private authService: AuthService
  ) {
    this.watchRemoteControlKeys();
  }

  ngOnInit(): void {
    this.channelService.list().subscribe((response: any) => {
      this.channels = response.channels;

      // retrieve and set last saved channel (if any)
      const savedChannel = ChannelHelper.getSavedChannelId();
      if (savedChannel > 0) {
        this.setChannelById(savedChannel);
      } else {
        // this.welcomeMessage = 'Olá, assista agora seus canais árabes ao vivo!';
        const fisrtChannel: any = this.channels[0].ID ;
        this.setChannelById(fisrtChannel);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.remoteMonitor) this.remoteMonitor.unsubscribe();
  }

  private setChannelById(channelId: number): void {
    if (!this.channels || this.channels.length < 1 || channelId < 1) return;
    const selectedChannel = this.channels.find(c => c.ID === channelId);
    const selectedChannelIndex = this.channels.findIndex(c => c.ID === channelId);

    if (selectedChannel && selectedChannelIndex !== -1) {
      this.currentChannel = selectedChannel;
      this.selectedIndex = selectedChannelIndex;

      ChannelHelper.saveLastChannelId(selectedChannel?.ID || 0);
    }
    // tocar o canal selecionado
    this.playerStore.dispatch(fromPlayerActions.PlayRequest({url: this.channels[selectedChannelIndex].Url, PiP: true}));
  }

  private setChannel(index: number): void {
    this.selectedIndex = index;
    this.currentChannel = this.channels[index];

    // save to storage, if user closes app it will return to same channel
    ChannelHelper.saveLastChannelId(this.currentChannel?.ID || 0);

    // toca o canal quando navega
    this.playerStore.dispatch(fromPlayerActions.PlayRequest({url: this.channels[index].Url, PiP: true}));
  }

  private watchRemoteControlKeys(): void {

    this.remoteMonitor = this.remote.OnKeyPress.subscribe(re => {
      // Disable welcome message and focus on first channel
      if (this.welcomeMessage) {
        this.welcomeMessage = '';
        this.setChannel(0);
        return;
      }
      if (re.RemoteKey === RemoteControlKey[RemoteControlKey.Up]) {
        const newIndex = this.selectedIndex - this.columns;
        if (newIndex >= 0) {this.playerStore.dispatch(fromPlayerActions.StopRequest()); this.setChannel(newIndex); }
        return;
      }

      if (re.RemoteKey === RemoteControlKey[RemoteControlKey.Down]) {
        const newIndex = this.selectedIndex + this.columns;
        if (newIndex < this.channels.length) {this.playerStore.dispatch(fromPlayerActions.StopRequest()); this.setChannel(newIndex); }
        return;
      }

      if (re.RemoteKey === RemoteControlKey[RemoteControlKey.Right]) {
        const newIndex = this.selectedIndex + 1;
        if (newIndex < this.channels.length) {this.playerStore.dispatch(fromPlayerActions.StopRequest()); this.setChannel(newIndex); }
        return;
      }

      if (re.RemoteKey === RemoteControlKey[RemoteControlKey.Left]) {
        const newIndex = this.selectedIndex - 1;
        if (newIndex >= 0) {this.playerStore.dispatch(fromPlayerActions.StopRequest()); this.setChannel(newIndex); }
        return;
      }

      if (re.RemoteKey === RemoteControlKey[RemoteControlKey.OK]) {
        this.router.navigate(['/channel', this.currentChannel.ID, 'watch']);
      }

      if (re.RemoteKey === RemoteControlKey[RemoteControlKey.One]) {

        // TODO: mode de resetar localstorage
        if(localStorage.getItem('restPasswordOne') == undefined){
          localStorage.setItem('restPasswordOne','one')
        }else{
          localStorage.removeItem('restPasswordOne')
          localStorage.removeItem('restPasswordFive')
          localStorage.removeItem('restPasswordNine')
        }
        this.authService.resetPassword();

      }else if (re.RemoteKey === RemoteControlKey[RemoteControlKey.Five]) {

        // TODO: mode de resetar localstorage
        if(localStorage.getItem('restPasswordFive') == undefined){
          localStorage.setItem('restPasswordFive','five')
        }else{
          localStorage.removeItem('restPasswordOne')
          localStorage.removeItem('restPasswordFive')
          localStorage.removeItem('restPasswordNine')
        }
        this.authService.resetPassword();

      }else if (re.RemoteKey === RemoteControlKey[RemoteControlKey.Nine]) {

        // TODO: mode de resetar localstorage
        if(localStorage.getItem('restPasswordNine') == undefined){
          localStorage.setItem('restPasswordNine','nine')
        }else{
          localStorage.removeItem('restPasswordOne')
          localStorage.removeItem('restPasswordFive')
          localStorage.removeItem('restPasswordNine')
        }
        this.authService.resetPassword();
      }else if (re.RemoteKey === RemoteControlKey[RemoteControlKey.Zero]) {
        this.authService.resetPassword();
      }
    });
  }
}
